import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { UPDATE_PASSWORD } from 'actionTypes';
import { isActionInProgress } from 'selectors';
import { passwordConfirmationValidation } from 'services/validationHelpers';

import Form from 'Components/Form';

import { Modal, Text } from 'frontend-component-library';

export const PASSWORD_UPDATE_KEY = 'password_update';

class PasswordUpdateForm extends Component {
  handleSubmit = ({ password }) => {
    const { updatePassword, resetToken } = this.props;
    updatePassword(resetToken, password);
  };

  render() {
    const { closeModal, isFetching, errors } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2 className="">Reset Password</h2>
        </Modal.Header>
        <Modal.Section>
          <Form
            onSubmit={this.handleSubmit}
            disabled={isFetching}
            submitText="Update Password"
            errors={errors}
            className="AuthForm"
          >
            <Text
              name="password"
              text="New Password"
              placeholder="Enter new password"
              type="password"
              required
            />
            <Text
              name="password_confirmation"
              text="Confirm Password"
              placeholder="Re-enter Password"
              type="password"
              onChange={this.fakeOnChange}
              required
              validationCallback={passwordConfirmationValidation}
            />
          </Form>
        </Modal.Section>
      </React.Fragment>
    );
  }
}

PasswordUpdateForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isFetching: isActionInProgress(state, UPDATE_PASSWORD),
    errors: state.endpointErrors[UPDATE_PASSWORD],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updatePassword: actions.updatePassword,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordUpdateForm);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/PasswordUpdateForm.js